import GalleryItem from "./GalleryItem"
import { makeid } from "~/helpers/common.helpers";

export default function Gallery({items, prefix, addFill = false}) {
  
  // if(addFill){
  //   const block = {
  //     _id: "blank",
  //     title: "blank",
  //     slug: {
  //         current: "blank",
  //     },
  //     smallImage: "",
  //     fill: true,
  //   }

  //   items.splice(1, 0, block);
  //   items.splice(6, 0, block);
  //   items.splice(8, 0, block);  

  // }

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
      {items.length ? (
          items.map((item) => (
            <GalleryItem 
              key={item._id + makeid(5)} 
              id={item._id} 
              title={item.title} 
              href={item.isLink ? item.linkUrl : prefix + item.slug.current} 
              image={item.smallImage} 
              fill={!item.fill ? false : true} 
            />
          ))
        ) : (
          <></>
        )}
    </div>
  );
}
   